module.exports = __webpack_public_path__ + "static/img/authorize-paper.798a104a.png";